var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"none"}},[_c('video',{ref:"videoPlayer",staticClass:"video-js vjs-default-skin post-detail-video",attrs:{"id":"video","crossorigin":"anonymous","playsinline":"","controls":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }